import React from "react"
import { withRouter } from "react-router-dom"
import axios from "axios"
import { toast } from "react-toastify"
import { Button, Container, Header, Message, Grid } from "semantic-ui-react"

import "./ApplicationPrint.css"
import { Config } from "./../Auth"
import OfflinePrint from "components/OfflinePrint"

class ApplicationPrint extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      dataIsLoading: true,
      perifereies: [],
      dimoi: [],
      logoiMetathesis: [],
      theseisExoterikou: [],
      theseisEythinis: [],
      application: {},
      isFinal: false,
      onlyAbroad: false
    }
  }

  componentDidMount() {
    if (this.props.user.access_token) {
      axios
        .get(Config.reportApi, {
          headers: {
            Authorization: `Bearer ${this.props.user.access_token}`
          }
        })
        .then((res) => {
          this.setState({
            perifereies: res.data.perifereies,
            dimoi: res.data.dimoi,
            logoiMetathesis: res.data.logoiMetathesis,
            theseisExoterikou: res.data.theseisExoterikou,
            theseisEythinis: res.data.theseisEythinis,
            application: res.data.application,
            dataIsLoading: false
          })
        })
        .catch((error) => {
          toast.error("Αποτυχία μεταφοράς δεδομένων", {
            position: "bottom-right",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          })
        })

      axios
        .get(Config.checkApi, {
          headers: {
            Authorization: `Bearer ${this.props.user.access_token}`
          }
        })
        .then((res) => {
          this.setState({
            isFinal: res.data.isFinal,
            onlyAbroad: res.data.onlyAbroad
          })
        })
    }
  }

  render() {
    const {
      application,
      theseisEythinis,
      theseisExoterikou,
      perifereies,
      dimoi,
      logoiMetathesis,
      isFinal,
      onlyAbroad
    } = this.state

    const { user } = this.props

    const getDescriptionThesiEfthynhs = (thesiId) => {
      const thesi = theseisEythinis.find((p) => p.thefId === thesiId)
      return thesi ? thesi.monada + "-" + thesi.kathikon : null
    }

    const getDescriptionTheseonExoterikou = () => {
      return application.epithymiesExoterikou
        ? application.epithymiesExoterikou
            .map((thesiId) =>
              theseisExoterikou.find((p) => p.exotId === thesiId)
            )
            .map((thesi) => thesi.kodikos)
            .join(",")
        : null
    }

    const getPerifereiaDescription = (periferiaId) => {
      return periferiaId
        ? perifereies.find((p) => p.perifId === periferiaId).desc
        : null
    }

    const getDimosDescription = (dimosId) => {
      return dimosId ? dimoi.find((p) => p.dimosId === dimosId).desc : null
    }

    const getLogosDescription = (logosId) => {
      return logosId
        ? logoiMetathesis.find((p) => p.logosId === logosId).desc
        : null
    }

    const getCheckBoxDescritpion = (value) => {
      return value ? "ΝΑΙ" : "ΟΧΙ"
    }
    const ama = application.ama
    const epithymiaMetathesis = getCheckBoxDescritpion(
      application.epithymiaMetathesis
    )
    const epithymiaDietias = getCheckBoxDescritpion(
      application.epithymiaDietias
    )
    const datecreated = application.datecreated

    const anafora = getCheckBoxDescritpion(application.anafora)
    const selectedPerifereiaA = application.epithymiaMetathesis
      ? getPerifereiaDescription(application.selectedPerifereiaA)
      : "ΤΡΕΧΟΥΣΑ ΕΠΙΛΟΓΗ"
    const selectedDimosA = application.epithymiaMetathesis
      ? getDimosDescription(application.selectedDimosA)
      : "ΤΡΕΧΟΥΣΑ ΕΠΙΛΟΓΗ"
    const selectedLogosA = application.epithymiaMetathesis
      ? getLogosDescription(application.selectedLogosA)
      : "ΤΡΕΧΟΥΣΑ ΕΠΙΛΟΓΗ"
    const selectedPerifereiaB = getPerifereiaDescription(
      application.selectedPerifereiaB
    )
    const selectedDimosB = getDimosDescription(application.selectedDimosB)
    const selectedLogosB = getLogosDescription(application.selectedLogosB)
    const selectedPerifereiaC = getPerifereiaDescription(
      application.selectedPerifereiaC
    )
    const selectedDimosC = getDimosDescription(application.selectedDimosC)
    const selectedLogosC = getLogosDescription(application.selectedLogosC)
    const exoterikou = getDescriptionTheseonExoterikou()
    const thesiEythinisA = getDescriptionThesiEfthynhs(
      application.thesiEythinisA
    )
    const thesiEythinisB = getDescriptionThesiEfthynhs(
      application.thesiEythinisB
    )
    const thesiEythinisC = getDescriptionThesiEfthynhs(
      application.thesiEythinisC
    )

    const print = application.isFinal ? (
      <div className="noprint">
        <Container textAlign="left" style={{ paddingBottom: "30px" }}>
          <Message>
            <Grid verticalAlign="middle" stackable>
              <Grid.Column floated="left" width={8}>
                <Header size="small">
                  Έχετε οριστικοποιήσει τη δήλωση σας
                </Header>
              </Grid.Column>
              <Grid.Column floated="right" width={4}>
                <Button
                  floated="right"
                  fluid
                  primary
                  onClick={() => window.print()}>
                  Εκτύπωση δήλωσης
                </Button>
              </Grid.Column>
            </Grid>
          </Message>
        </Container>
      </div>
    ) : (
      ""
    )
    if (!isFinal) return <OfflinePrint user={user} />

    function getSubmissionDateFromId(objectId) {
      // try {
      // Ensure the objectId is a valid 24-character hexadecimal string
      if (!objectId || objectId.length !== 24) {
        console.error("Invalid ObjectId format.")
        return null
      }

      // The first 4 bytes of ObjectId represent the timestamp
      const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000
      return new Date(timestamp) // Convert to JavaScript Date object
      // } catch (error) {
      //   console.error("Error extracting submission date from ObjectId:", error)
      //   return null // Return null if there's an error
      // }
    }
    // Check if `application` exists and extract the date if it does
    const submissionDate = application?.id
      ? getSubmissionDateFromId(application.id) || "Δεν υπάρχει ημερομηνία"
      : null
    console.log("Submission Date:", submissionDate)

    return (
      <div className="main-container">
        {print}
        <div className="kmh-doc printable">
          <div className="title">
            ΕΝΤΥΠΟ ΑΤΟΜΙΚΩΝ ΣΤΟΙΧΕΙΩΝ - ΕΠΙΚΑΙΡΟΠΟΙΗΜΕΝΩΝ ΕΠΙΘΥΜΙΩΝ ΜΕΤΑΘΕΣΕΩΝ
            ΕΤΟΥΣ {process.env.REACT_APP_YEAR}
          </div>
          <div className="heading1">ΑΤΟΜΙΚΑ ΣΤΟΙΧΕΙΑ</div>
          <table>
            <thead>
              <tr>
                <th className="smallwidth">ΒΑΘΜΟΣ</th>
                <th className="smallwidth">ΕΙΔΙΚΟΤΗΤΑ</th>
                <th>ΕΠΩΝΥΜΟ</th>
                <th>ΟΝΟΜΑ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <br />
                </td>
                <td />
                <td />
                <td />
              </tr>
              <tr>
                <th style={{ height: "3px" }} />
                <th />
                <th />
                <th />
              </tr>
              <tr>
                <th>ΑΜΑ</th>
                <th>ΑΔΤ</th>
                <th>ΜΟΝΑΔΑ</th>
                <th>ΕΞΕΙΔΙΚΕΥΣΗ</th>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                  {ama != null ? ama : <br />}
                </td>
                <td />
                <td />
                <td />
              </tr>
            </tbody>
          </table>

          {onlyAbroad === false && (
            <>
              <div style={{ marginTop: "8px" }}>
                ΕΠΙΘΥΜΩ ΜΕΤΑΘΕΣΗ : <b>{epithymiaMetathesis}</b>
              </div>
              <div>
                ΕΠΙΘΥΜΩ ΜΕΤΑΘΕΣΗ ΣΕ ΜΟΝΑΔΑ ΔΙΕΤΙΑΣ: <b>{epithymiaDietias}</b>
              </div>
              <div className="heading1">ΕΠΙΘΥΜΙΕΣ ΜΕΤΑΘΕΣΗΣ</div>
              <table>
                <thead>
                  <tr>
                    <th />
                    <th className="max70">ΠΕΡΙΦ. ΕΝΟΤΗΤΑ</th>
                    <th className="max70">ΔΗΜΟΣ</th>
                    <th className="max70">ΛΟΓΟΣ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="tinywidth" style={{ textAlign: "left" }}>
                      Α
                    </th>
                    <td>{selectedPerifereiaA}</td>
                    <td>{selectedDimosA}</td>
                    <td>{selectedLogosA}</td>
                  </tr>
                  <tr>
                    <th className="tinywidth" style={{ textAlign: "left" }}>
                      Β
                    </th>
                    <td>{selectedPerifereiaB}</td>
                    <td>{selectedDimosB}</td>
                    <td>{selectedLogosB}</td>
                  </tr>
                  <tr>
                    <th className="tinywidth" style={{ textAlign: "left" }}>
                      Γ
                    </th>
                    <td>{selectedPerifereiaC}</td>
                    <td>{selectedDimosC}</td>
                    <td>{selectedLogosC}</td>
                  </tr>
                </tbody>
              </table>
              <div style={{ marginTop: "8px" }}>
                ΑΝΑΦΟΡΑ (επιθυμία συνυπηρέτησης, ένταξη σε κοινωνικά κριτήρια) :{" "}
                <b>{anafora}</b>
              </div>
              <table style={{ marginTop: "8px" }}>
                <tbody>
                  <tr>
                    <th className="smallwidth center-text">
                      ΕΠΙΘΥΜΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΕΞΩΤΕΡΙΚΟΥ
                    </th>
                    <td>{exoterikou}</td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          <table style={{ marginTop: "8px" }}>
            <tbody>
              <tr>
                <th className="smallwidth center-text">
                  ΕΠΙΘΥΜΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΕΞΩΤΕΡΙΚΟΥ
                </th>
                <td>{exoterikou}</td>
              </tr>
            </tbody>
          </table>
          {!onlyAbroad === false && (
            <>
              <div className="heading1">ΕΠΙΘΥΜΙΕΣ ΘΕΣΕΩΝ ΕΥΘΥΝΗΣ</div>
              <table>
                <tbody>
                  <tr>
                    <th className="tinywidth" style={{ textAlign: "left" }}>
                      Α
                    </th>
                    <td>{thesiEythinisA}</td>
                  </tr>
                  <tr>
                    <th className="tinywidth" style={{ textAlign: "left" }}>
                      Β
                    </th>
                    <td>{thesiEythinisB}</td>
                  </tr>
                  <tr>
                    <th className="tinywidth" style={{ textAlign: "left" }}>
                      Γ
                    </th>
                    <td>{thesiEythinisC}</td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          <ul>
            {/* <li>
              Έχω λάβει γνώση της αναλυτικής μοριοδότησης και της ατομικής
              καρτέλας μου και ενημερώθηκα για τις οδηγίες και τις τεθείσες
              προθεσμίες, όπως αυτές καθορίζονται στη Διαταγή Μεταθέσεων Έτους{" "}
              {process.env.REACT_APP_YEAR}.
            </li> */}
            <li>
              Πιστοποιώ ότι τα παραπάνω στοιχεία είναι αληθή και επέχουν θέση
              Υπεύθυνης Δήλωσης.
            </li>
          </ul>
          <br />
          <div className="sign">Υπογραφή</div>
          <div style={{ marginTop: "120px" }}>
            Το παρόν υποβλήθηκε ηλεκτρονικά σε ΓΕΑ/Β1 με κωδικό αίτησης:&nbsp;
            {application.id} στις:&nbsp;
            {submissionDate
              ? submissionDate?.toLocaleString("el-GR", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit"
                })
              : "Η ημερομηνία δεν είναι διαθέσιμη"}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(ApplicationPrint)
